'use client'

import { useQuery } from '@tanstack/react-query'
import { useTranslations } from 'next-intl'

import api from '@/api/client'
import { LocalDateTime } from '@/lib/datetime/LocalDateTime'

import S from '../ClubModeration.module.scss'

export function SupportTicketsList() {
  const t = useTranslations('clubs.moderation')

  const { data: ticket, isLoading } = useQuery({
    queryKey: ['clubs', 'support-tickets', 'me'],
    queryFn: () => api.v2ClubsSupportTicketsMeList()
  })

  if (isLoading) {
    return (
      <div className={S.supportTicketsBlock}>
        <h3 className={S.supportTicketsTitle}>{t('supportTickets.title')}</h3>
        <p className={S.supportTicketsEmpty}>{t('supportTickets.loading')}</p>
      </div>
    )
  }

  const tickets = Array.isArray(ticket) ? ticket : ticket ? [ticket] : []

  return (
    <div className={S.supportTicketsBlock}>
      <h3 className={S.supportTicketsTitle}>{t('supportTickets.title')}</h3>
      {tickets.length === 0 ? (
        <p className={S.supportTicketsEmpty}>{t('supportTickets.empty')}</p>
      ) : (
        <ul className={S.supportTicketsList}>
          {tickets.map((item, index) => (
            <li key={item.id ?? index} className={S.supportTicketsItem}>
              <p className={S.supportTicketsMessage}>{item.message ?? '—'}</p>
              <div className={S.supportTicketsMeta}>
                <span className={S.supportTicketsStatus}>
                  {item.status ?? '—'}
                </span>
                <span className={S.supportTicketsDate}>
                  <LocalDateTime value={item.created_at} preset="dateTime" />
                </span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
